import { render, staticRenderFns } from "./BookingDeleteDialog.vue?vue&type=template&id=21d39f58&scoped=true"
import script from "./BookingDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./BookingDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./BookingDeleteDialog.vue?vue&type=style&index=0&id=21d39f58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d39f58",
  null
  
)

export default component.exports